<template>
  <div class="col-md-12 fc-calendar-widget">
    <div ref='calendar'></div>
  </div>
</template>

<script>
import { Calendar }            from '@fullcalendar/core'
import dayGridPlugin           from '@fullcalendar/daygrid'
import timeGridPlugin          from '@fullcalendar/timegrid'
import allLocale               from '@fullcalendar/core/locales-all'
import CalendarTranslator      from './../../model/translator/CalendarTranslator'
import bootstrap               from '@fullcalendar/bootstrap'
import { formatWeekTitleDate } from '../../utils/calendar.utils'
import { PrepareTooltipData }  from '../../model/prepareTooltipData'

export default {
  name:  'CalendarBlock',
  props: ['item'],

  data () {
    return {
      events:  [],
      minTime: '06:00:00',
      maxTime: '18:00:00',

      months:          [],
      monthsShort:     [],
      days:            [],
      daysShort:       [],
      allDayText:      'all day',
      buttonText:      {
        today: 'today',
        month: 'month',
        week:  'week',
        day:   'day',
        list:  'list'
      },
      tooltip:         null,
      tooltipRenderer: new PrepareTooltipData()
    }
  },

  created () {
    this._prepareEvents()

    let translator = new CalendarTranslator(this.$translate)

    this.months      = translator.getMonths()
    this.monthsShort = translator.getShortMonths()
    this.days        = translator.getDays()
    this.daysShort   = translator.getShortDays()
    this.allDayText  = this.$translate.text('date_all_day')
    this.month       = this.$translate.text('date_month')

    this.buttonText = {
      today: this.$translate.text('date_today'),
      month: this.$translate.text('date_month'),
      week:  this.$translate.text('date_week'),
      day:   this.$translate.text('date_day'),
      list:  this.$translate.text('date_list')
    }
  },

  mounted () {
    let calendar = new Calendar(this.$refs.calendar, {
      plugins:            [dayGridPlugin, timeGridPlugin, bootstrap],
      themeSystem:        'bootstrap',
      header:             {
        left:   '',
        center: 'prev,title,next,switchDay,today',
        right:  'switchDay,today,timeGridDay,timeGridWeek,dayGridMonth'
      },
      // slotLabelFormat: 'HH:mm',
      // timeFormat:      'HH:mm',
      height:             'auto',
      locales:            [allLocale],
      locale:             this.$user.languageCode.toLowerCase(),
      defaultDate:        new Date(),
      defaultView:        'timeGridWeek',
      // slotDuration:    '01:00:00',
      minTime:            this.minTime,
      maxTime:            this.maxTime,
      navLinks:           true, // can click day/week names to navigate views
      editable:           true,
      firstDay:           1,
      eventLimit:         true, // allow "more" link when too many events
      events:             this.events,
      monthNames:         this.months,
      monthNamesShort:    this.monthsShort,
      dayNames:           this.days,
      dayNamesShort:      this.daysShort,
      allDayText:         this.allDayText,
      buttonText:         this.buttonText,
      allDaySlot:         false,
      titleFormat:        {
        month:   'long',
        year:    'numeric',
        day:     'numeric',
        weekday: 'long'
      },
      views:              {
        dayGridMonth: {
          titleFormat: {
            month: 'long',
            year:  'numeric'
          }
        },
        timeGridWeek: {
          titleFormat:     (date) => {
            return formatWeekTitleDate(date)
          },
          slotLabelFormat: {
            hour:           'numeric',
            minute:         '2-digit',
            omitZeroMinute: false,
            meridiem:       false,
            hour12:         false
          },
          navLinks:        false
        },
        timeGridDay:  {
          slotLabelFormat: {
            hour:           'numeric',
            minute:         '2-digit',
            omitZeroMinute: false,
            meridiem:       false,
            hour12:         false
          },
          navLinks:        false
        }
      },
      viewSkeletonRender: (info) => {
        for (const el of info.el.querySelectorAll('a.fc-cell-text')) {
          const date = JSON.parse(el.dataset.goto).date
          el.onclick = () => {
            setTimeout(
              () => {
                calendar.changeView('timeGridDay', date)
              },
              0
            )
          }
        }

        let tr = (key) => {
          return this.$translate.text(key)
        }

        let translator = new CalendarTranslator(this.$translate)

        $.fn.datepicker.dates['own'] =
          {
            days:        translator.getDays(),
            daysShort:   translator.getShortDays(),
            daysMin:     translator.getMinDays(),
            months:      translator.getMonths(),
            monthsShort: translator.getShortMonths(),
            today:       tr('date_today'),
            clear:       tr('date_clear'),
            titleFormat: 'MM yyyy'
          }

        let dateElement = $('.fc-switchDay-button')

        dateElement
          .datepicker({
            format:         'dd.mm.yyyy',
            todayHighlight: true,
            orientation:    'left auto',
            language:       'own',
            weekStart:      1,
            autoClose:      true,
            todayBtn:       true
            // clearBtn:       true
          })
          .on('changeDate', (event) => {
            if (!event.date) {
              return
            }

            calendar.changeView('timeGridDay', event.date)

            dateElement.datepicker('hide')
          })

      },
      datesRender:        (info) => {
        for (const el of info.el.querySelectorAll('a.fc-cell-text')) {
          const date = JSON.parse(el.dataset.goto).date
          el.onclick = () => {
            setTimeout(
              () => {
                calendar.changeView('timeGridDay', date)
              },
              0
            )
          }
        }
      },
      customButtons:      {
        switchDay: {
          text:                 '',
          bootstrapFontAwesome: 'calendar'
        }
      },
      eventClick:         (info) => {
        if (this.tooltip) {
          this.tooltip.hide()
        }

        if (!info.event.id || info.event.id === 'null') {
          return
        }

        this.$router.push({
          name:   'PageDynamicEditor',
          params: { page: info.event.extendedProps.entityCode, idStructure: '0', id: info.event.id, redir: 'grid' }
        })
      },
      eventRender:        (info) => {
        this.tooltipRenderer.prepare(
          info.el,
          info.event.extendedProps.entityCode,
          info.event.id,
          () => {},
          (error) => this.handleApiError(error),
          this.$translate
        )
      }
    })

    calendar.render()
  },

  methods: {

    /**
     *
     * @private
     */
    _prepareEvents () {
      if (!this.item.hasOwnProperty('FieldValues')) {
        return
      }

      if (this.item.FieldValues.length) {
        this.minTime = '06:00:00'
        this.maxTime = '18:00:00'
      }

      for (let i = 0; i < this.item.FieldValues.length; i++) {
        let innerItem = this.item.FieldValues[i]

        if (!innerItem.End && !innerItem.Start) {
          continue
        }

        this._setStartEndTime(innerItem)

        this.events.push({
          id:              innerItem.id,
          start:           innerItem.Start,
          end:             innerItem.End,
          title:           innerItem.Title,
          backgroundColor: innerItem.TaskStatusColor,
          borderColor:     innerItem.TaskStatusColor,
          entityCode:      innerItem.tEntityCode
        })
      }
    },

    /**
     *
     * @param item
     * @private
     */
    _setStartEndTime (item) {
      let itemStartTimeExplode = item.Start.split('T'),
          itemStartTime        = itemStartTimeExplode[1],
          itemEndTimeExplode   = item.End.split('T'),
          itemEndTime          = itemEndTimeExplode[1]

      if (this.minTime > itemStartTime) {
        this.minTime = itemStartTime
      }

      if (this.maxTime < itemEndTime) {
        this.maxTime = itemEndTime
      }

    }
  }
}
</script>

<style>
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/timeline/main.css';
@import '~@fullcalendar/timegrid/main.css';
@import '~@fullcalendar/resource-timeline/main.css';

.fc-calendar-widget {
  margin-bottom: 20px;
}

.fc-calendar-widget .fc-view table {
  width: 100%;
}

.fc-calendar-widget .fc-toolbar .fc-center {
  display: flex;
}

.fc-calendar-widget .fc-toolbar {
  margin-top: 20px;
}

.fc-event-container .fc-content .fc-title,
.fc-event-container .fc-content .fc-time {
  color: #ffffff;
}

.fc-time-grid-event.fc-event {
  min-width: 20px;
}

.fc-header-toolbar h2 {
  font-weight: 500;
  font-size: 17px;
}

.fc-header-toolbar.fc-toolbar > * > :not(:first-child) {
  margin-left: 0.75rem;
}

.fc-calendar-widget .fc-center div {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.fc-calendar-widget .alert-info {
  background-color: #b0d49a !important;
  border-color: #bee5eb !important;
}

.fc-calendar-widget .fc-sat,
.fc-calendar-widget .fc-sun {
  background: #d2d2d2;
}

.fc-center .fc-next-button {
  margin-left: 10px;
}

.fc-center .fc-prev-button {
  margin-right: 10px;
}

.fc-center .fc-switchDay-button {
  margin: 0 10px;
}

.fc-center .fc-prev-button {
  margin-right: 10px;
}

.fc-calendar-widget .fc-right .fc-today-button,
.fc-calendar-widget .fc-right .fc-switchDay-button {
  display: none;
}

.fc-calendar-widget .fc-right .btn-group > .fc-timeGridDay-button.btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
  border-top-left-radius: .215rem;
  border-bottom-left-radius: .215rem;
}

@media (max-width: 550px) {
  .fc-calendar-widget .fc-header-toolbar h2 {
    font-size: 14px;
  }
}

@media (max-width: 767px) {
  .fc-header-toolbar {
    flex-flow: column;
  }

  .fc-header-toolbar .fc-right {
    margin-top: 15px;
  }

  .fc-calendar-widget .fc-center .fc-today-button,
  .fc-calendar-widget .fc-center .fc-switchDay-button {
    display: none;
  }

  .fc-calendar-widget .fc-right .fc-today-button,
  .fc-calendar-widget .fc-right .fc-switchDay-button {
    display: inline;
  }

  .fc-calendar-widget .fc-right .btn-group > .fc-timeGridDay-button.btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

</style>
